const createComparedXML = (ecgSamples: number[]) => {
  const xmlString = `<?xml version="1.0" encoding="ISO-8859-1"?>
  <!--
        FDA Annotated ECG
        Generated by AMPS_CalECG_4.1.0 using
        FDAHL7 aECG output plugin Output Plugin for PluginSystem v2.4.0 - Amps llc (www.amps-llc.com)
        on 2022-Oct-27 16:19:25 (GMT+2)
  -->
  <AnnotatedECG xmlns="urn:hl7-org:v3" xmlns:voc="urn:hl7-org:v3/voc" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="urn:hl7-org:v3 files\
  PORI_MT020001.xsd" type="Observation" classCode="OBS" moodCode="EVN">
    <id root="980f6f46-2000-4145-953e-5254b5d873c6"/>
    <code code="93000" codeSystem="2.16.840.1.113883.6.12" codeSystemName="CPT-4" displayName="Electrocardiogram"/>
    <effectiveTime>
      <low value="20050626102001.000" inclusive="true"/>
      <high value="20050626102031.000" inclusive="false"/>
    </effectiveTime>
    <componentOf typeCode="COMP" contextConductionInd="true">
      <timepointEvent classCode="CTTEVENT" moodCode="EVN">
        <componentOf typeCode="COMP" contextConductionInd="true">
          <subjectAssignment classCode="CLNTRL" moodCode="EVN">
            <subject typeCode="SBJ" contextControlCode="OP">
              <trialSubject classCode="RESBJ">
                <id extension="101"/>
                <subjectDemographicPerson classCode="PSN" determinerCode="INSTANCE">
                  <name>C-M</name>
                  <administrativeGenderCode code="F" codeSystem="2.16.840.1.113883.5.1"/>
                  <birthTime value="20060411"/>
                </subjectDemographicPerson>
              </trialSubject>
            </subject>
            <componentOf typeCode="COMP" contextConductionInd="true">
              <clinicalTrial classCode="CLNTRL" moodCode="EVN">
                <id root="1.3.6.1.4.1.21123.3.1" extension="AMPS_UNK_CLINICALTRIAL"/>
                <location typeCode="LOC" contextControlCode="AP">
                  <trialSite classCode="SDLOC">
                    <id extension="1"/>
                  </trialSite>
                </location>
              </clinicalTrial>
            </componentOf>
          </subjectAssignment>
        </componentOf>
      </timepointEvent>
    </componentOf>
    <component typeCode="COMP" contextConductionInd="true">
      <series classCode="OBSSER" moodCode="EVN">
        <id root="16e086f8-3a66-406f-b4f4-605a9566cb67"/>
        <code code="RHYTHM" codeSystem="2.16.840.1.113883.5.4" codeSystemName="ActCode" displayName="ECG Rhythm Waveforms"/>
        <effectiveTime>
          <low value="20050626102001.000" inclusive="true"/>
          <high value="20050626102031.000" inclusive="false"/>
        </effectiveTime>
        <author typeCode="AUT" contextControlCode="OP">
          <seriesAuthor classCode="MANU">
            <manufacturedSeriesDevice classCode="DEV" determinerCode="INSTANCE">
              <id extension="1092"/>
              <manufacturerModelName>el250</manufacturerModelName>
            </manufacturedSeriesDevice>
            <manufacturerOrganization classCode="ORG" determinerCode="INSTANCE">
              <name>Mortara Instrument, Inc.</name>
            </manufacturerOrganization>
          </seriesAuthor>
        </author>
        <component typeCode="COMP" contextConductionInd="true">
          <sequenceSet classCode="OBSCOR" moodCode="EVN">
            <component typeCode="COMP" contextConductionInd="true">
              <sequence classCode="OBS" moodCode="EVN">
              <code code="TIME_ABSOLUTE" codeSystem="2.16.840.1.113883.5.4" codeSystemName="ActCode" displayName="Absolute Time Sequence"/>
                <value xsi:type="GLIST_TS">
                  <head value="20050626102001.000"/>
                  <increment value="0.001953" unit="s"/>
                </value>
              </sequence>
            </component>
            <component typeCode="COMP" contextConductionInd="true">
              <sequence classCode="OBS" moodCode="EVN">
                <code code="MDC_ECG_LEAD_I" codeSystem="2.16.840.1.113883.6.24" codeSystemName="MDC" displayName="I"/>
                <value xsi:type="SLIST_PQ">
                  <origin value="0" unit="uV"/>
                  <scale value="1.00" unit="uV"/>
                  <digits>${ecgSamples.join(' ')}</digits>
                </value>
              </sequence>
            </component>
          </sequenceSet>
        </component>
        <subjectOf typeCode="SUBJ">
          <annotationSet classCode="OBS" moodCode="EVN">
            <author typeCode="AUT" contextControlCode="OP">
              <assignedEntity classCode="ASSIGNED">
                <assignedAuthorType>
                  <assignedDevice classCode="DEV" determinerCode="INSTANCE">
                    <softwareName>CalECG v4.1.0</softwareName>
                    <playedManufacturedDevice classCode="MANU">
                      <manufacturerOrganization classCode="ORG" determinerCode="INSTANCE">
                        <name>Amps llc</name>
                      </manufacturerOrganization>
                    </playedManufacturedDevice>
                  </assignedDevice>
                </assignedAuthorType>
              </assignedEntity>
            </author>
          </annotationSet>
        </subjectOf>
      </series>
    </component>
  </AnnotatedECG>
  `;

  return xmlString;
  // return new DOMParser().parseFromString(xmlString, 'text/xml');
};

export { createComparedXML };
